import React from "react";
import useLanguage from "../../hooks/useLanguage";

export const NoData = () => {
  const { language } = useLanguage();
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 h-full">
      <div className="bg-gray-50 dark:bg-gray-700 rounded-full p-6 mb-4 shadow-inner">
        <svg
          stroke="currentColor"
          fill="currentColor"
          strokeWidth="0"
          viewBox="0 0 16 16"
          className="w-10 h-10 text-gray-400 dark:text-gray-200"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M6.146 6.146a.5.5 0 0 1 .708 0L8 7.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 8l1.147 1.146a.5.5 0 0 1-.708.708L8 8.707 6.854 9.854a.5.5 0 0 1-.708-.708L7.293 8 6.146 6.854a.5.5 0 0 1 0-.708"></path>
          <path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1"></path>
        </svg>
      </div>
      <p className="text-lg font-medium mb-1">{language.NO_DATA}</p>
    </div>
  );
};
